import React from 'react';
import ShipDateComponent from '../../../../../fulfillment-planner/ship-date/index';
import { ShipDateLabelWithoutColon } from '../../../../../fulfillment-planner/ship-date/label';

import style from './style.module.less';

export const ShipDate = () => {
  return (
    <>
      <div className={style.label}>
        <ShipDateLabelWithoutColon />
      </div>
      <ShipDateComponent calendarPosition='bottom-left' />
      <div />
    </>
  );
};
